'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AccordionItemTitle;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function AccordionItemTitle(_ref) {
  var className = _ref.className,
    expanded = _ref.expanded,
    onClick = _ref.onClick,
    onMouseOver = _ref.onMouseOver,
    Root = _ref.rootTag,
    title = _ref.title,
    uuid = _ref.uuid;
  var style = {
    cursor: 'pointer',
    margin: 0
  };
  if (_typeof(title) === 'object') {
    return _react["default"].cloneElement(title, {
      onClick: onClick,
      id: "react-sanfona-item-title-".concat(uuid),
      'aria-controls': "react-sanfona-item-body-".concat(uuid)
    });
  }
  return _react["default"].createElement(Root, {
    "aria-controls": "react-sanfona-item-body-".concat(uuid),
    "aria-expanded": expanded,
    className: (0, _classnames["default"])('react-sanfona-item-title', className),
    id: "react-sanfona-item-title-".concat(uuid),
    onClick: onClick,
    onMouseOver: onMouseOver,
    style: style
  }, title);
}
AccordionItemTitle.defaultProps = {
  rootTag: 'h3'
};